import { Message } from "./Types";

export const PROJECT_TITLE = "MEQ Insights";
export const COPY_RIGHT = `Copyright © MEQ ${new Date().getFullYear()}`;

export const SUCCESS_CODE = 700;

export const DEFAULT_SPACING = 3;
export const DEFAULT_SPACING_MOBILE = 1.5;
export const DEFAULT_BORDER_RADIUS = "0.5rem";

// Scroll-area max-height for a full-size table shown inside a dialog. The
// DialogWrapper content caps at 90vh; this fills most of that (minus the
// table's toolbar/pagination chrome) so a long table uses the screen and
// scrolls internally, while a short one still sizes to its rows.
export const DIALOG_TABLE_MAX_HEIGHT = "calc(90vh - 160px)";

// Scroll-area max-height for a table that sits at the bottom of a scrolling
// dashboard (charts above it). fillHeight doesn't fit there — the page scrolls
// as a whole — so cap the table at most of the viewport (less the page header
// chrome) rather than the default 480px, so it uses the screen when scrolled to
// and still sizes to content when short.
export const DASHBOARD_TABLE_MAX_HEIGHT = "calc(100vh - 270px)";

export const DEFAULT_MESSAGE: Message = { text: null, type: "error" } as const;

export const SUPER_ADMIN = "AllOrgs-SuperAdmin";
export const SUPER_USER = "AllOrgs-SuperUser";
export const ADMIN = "Admin"; // manage all resources for the org

export const WORDS_EXCLUDING_FROM_PAGE_TITLE = ["GMP"];

export const QUERY_DATA_SOURCE_ENDPOINT = "GetDataSource";
export const DATA_POOL_ITEM_EXPIRED_IN_MILLISECONDS = 60 * 60 * 1000; // 60 minutes
export const DEFAULT_NUMBER_OF_BINS = 8;

export const MAIN_ENTRY_PAGE = "/main";

export const CHART_DATA_COUNT_THRESHHOLD = 1000;
export const HISTOGRAM_Y_AXIS_TITLE = "Count";
export const HISTOGRAM_Y_AXIS_TITLE_PERCENT = "Percentage %";
export const PERCENTAGE_OF = "Percentage Of";

export const UPPER_CASE_TERMS = [
  "AUS",
  "EMA",
  "EOD",
  "GLQ",
  "HCW",
  "HDW",
  "HSCW",
  "IMF",
  "JBS",
  "LMY",
  "MEQ",
  "MSA",
  "PIC",
  "RFID",
  "USDA",
];

export const ALL = "All";
export const ALL_LOCATIONS = "AllLocations";
export const ALL_BRANDS = "All Brands";
export const ALL_SUPPLIERS = "All Suppliers";
export const ALL_MOBS = "All Mobs";
export const ALL_PICS = "All PICs";
export const ALL_LOTS = "All Lots";

// Value used in the location dropdown to mean "combine every plant". The
// backend treats this wildcard as "aggregate across all locations".
export const ALL_LOCATIONS_VALUE = "*";

export const VIDEO_SAS_TOKEN =
  "?sp=r&st=2026-07-23T02:06:07Z&se=2028-07-23T10:21:07Z&spr=https&sv=2026-02-06&sr=c&sig=sK%2Flr6mCq7ulgvX2%2FYDLDlbzoF3ZZvzeFE%2BkaxwOZQg%3D";
export const WEBCAM_SAS_TOKEN =
  "?sp=r&st=2026-07-23T01:50:52Z&se=2028-07-23T10:05:52Z&spr=https&sv=2026-02-06&sr=c&sig=1vTl1nkvhk3ciNkLbAoUR7PBPqghj2dlwS7foZSQHc4%3D";

export const ISO_DATE_FORMAT = "YYYY-MM-DD";

export const MILLISECONDS = {
  MINUTE: 60 * 1000,
} as const;

// Stands in for the location while no org is current, next to "NotValidOrg".
export const NO_ORG_LOCATION = "NotValidLocation";
